import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _get from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/get.js";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { BaseClient, applySdkMetadata } from '@sentry/core';
import { getSDKSource, logger, createClientReportEnvelope, dsnToString } from '@sentry/utils';
import { DEBUG_BUILD } from './debug-build.js';
import { eventFromException as _eventFromException, eventFromMessage as _eventFromMessage } from './eventbuilder.js';
import { WINDOW } from './helpers.js';
import { createUserFeedbackEnvelope } from './userfeedback.js';

/**
 * Configuration options for the Sentry Browser SDK.
 * @see @sentry/types Options for more information.
 */

/**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */
var BrowserClient = /*#__PURE__*/function (_BaseClient) {
  _inherits(BrowserClient, _BaseClient);
  var _super = _createSuper(BrowserClient);
  /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */
  function BrowserClient(options) {
    var _this;
    _classCallCheck(this, BrowserClient);
    var sdkSource = WINDOW.SENTRY_SDK_SOURCE || getSDKSource();
    applySdkMetadata(options, 'browser', ['browser'], sdkSource);
    _this = _super.call(this, options);
    if (options.sendClientReports && WINDOW.document) {
      WINDOW.document.addEventListener('visibilitychange', function () {
        if (WINDOW.document.visibilityState === 'hidden') {
          _this._flushOutcomes();
        }
      });
    }
    return _this;
  }

  /**
   * @inheritDoc
   */
  _createClass(BrowserClient, [{
    key: "eventFromException",
    value: function eventFromException(exception, hint) {
      return _eventFromException(this._options.stackParser, exception, hint, this._options.attachStacktrace);
    }

    /**
     * @inheritDoc
     */
  }, {
    key: "eventFromMessage",
    value: function eventFromMessage(message) {
      var level = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'info';
      var hint = arguments.length > 2 ? arguments[2] : undefined;
      return _eventFromMessage(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
    }

    /**
     * Sends user feedback to Sentry.
     */
  }, {
    key: "captureUserFeedback",
    value: function captureUserFeedback(feedback) {
      if (!this._isEnabled()) {
        DEBUG_BUILD && logger.warn('SDK not enabled, will not capture user feedback.');
        return;
      }
      var envelope = createUserFeedbackEnvelope(feedback, {
        metadata: this.getSdkMetadata(),
        dsn: this.getDsn(),
        tunnel: this.getOptions().tunnel
      });

      // _sendEnvelope should not throw
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      this._sendEnvelope(envelope);
    }

    /**
     * @inheritDoc
     */
  }, {
    key: "_prepareEvent",
    value: function _prepareEvent(event, hint, scope) {
      event.platform = event.platform || 'javascript';
      return _get(_getPrototypeOf(BrowserClient.prototype), "_prepareEvent", this).call(this, event, hint, scope);
    }

    /**
     * Sends client reports as an envelope.
     */
  }, {
    key: "_flushOutcomes",
    value: function _flushOutcomes() {
      var outcomes = this._clearOutcomes();
      if (outcomes.length === 0) {
        DEBUG_BUILD && logger.log('No outcomes to send');
        return;
      }

      // This is really the only place where we want to check for a DSN and only send outcomes then
      if (!this._dsn) {
        DEBUG_BUILD && logger.log('No dsn provided, will not send outcomes');
        return;
      }
      DEBUG_BUILD && logger.log('Sending outcomes:', outcomes);
      var envelope = createClientReportEnvelope(outcomes, this._options.tunnel && dsnToString(this._dsn));

      // _sendEnvelope should not throw
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      this._sendEnvelope(envelope);
    }
  }]);
  return BrowserClient;
}(BaseClient);
export { BrowserClient };